<div *ngIf="efateSetupPk && !isLoadingSaved">
  <div class="ef-reports-status flex align-items-center justify-content-between mt-3">
    <span>{{ runStatusLabel }} &nbsp; <strong>{{ statusName }}</strong> &nbsp;
      <p-badge styleClass="{{ badgeStyle }}"></p-badge>
    </span>
    <app-button [label]="runButtonLabel" [disabled]="isLoading" (onClickEvent)="onRunClick()"></app-button>
  </div>
  <app-loading *ngIf="isLoading && !rowData.length" class="mt-3 flex align-items-center justify-content-center"></app-loading>
  <ag-grid-angular *ngIf="columnDefs.length && (rowData.length || !isLoading)" class="ag-theme-alpine ef-reports-grid mt-3" style="width: 100%;"
    [domLayout]="'autoHeight'" [columnDefs]="columnDefs" [rowData]="rowData" [defaultColDef]="defaultColDef"
    [rowHeight]="rowHeight" [headerHeight]="headerHeight" [groupHeaderHeight]="groupHeaderHeight"
    [suppressMovableColumns]="true" [suppressCellFocus]="true" (cellClicked)="onCellClicked($event)">
  </ag-grid-angular>
  <div *ngIf="columnDefs.length && showTimeNote && (rowData.length || !isLoading)" class="ef-reports-time-note mt-2">
    <strong>{{ timeNoteLabel }}</strong>
    <span *ngFor="let note of timeNotes">{{ note.marker }} {{ note.label }}</span>
  </div>
</div>

<p-dialog [header]="previewTitle" [(visible)]="previewVisible" [modal]="true" [maximizable]="true"
  [draggable]="false" [resizable]="false" [style]="{ width: '60vw', height: '85vh' }" (onHide)="closePreview()">
  <div class="ef-reports-preview-box">
    <app-loading *ngIf="previewLoading" class="ef-reports-preview-loading"></app-loading>
    <iframe *ngIf="previewUrl" class="ef-reports-preview-frame" sandbox="" [src]="previewUrl" [title]="previewTitle"></iframe>
  </div>
  <ng-template pTemplate="footer">
    <app-button [label]="downloadButtonLabel" [disabled]="previewLoading || !previewUrl" (onClickEvent)="downloadReport()"></app-button>
  </ng-template>
</p-dialog>

<app-loading class="mt-2 flex align-items-center justify-content-center" *ngIf="isLoadingSaved"></app-loading>